import { SlackNotifySettings, SlackNotifySettingsUpdate } from '../../Model/SlackNotifySettings';
import { AccountRepository } from '../Repositories/AccountRepository';

export class UpdateSlackNotifySettingsUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(dto: SlackNotifySettingsUpdate): Promise<SlackNotifySettings> {
    return this.repo.updateSlackNotifySettings(dto)
      .then(res => res)
      .catch(err => Promise.reject(err));
  }
}
